import React, { Component } from 'react';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';

import Utils from 'yeffect/utils';
import * as Actions from '../auth/store/actions';
import {API} from "../config";

export default function (ComposedComponent) {
	class LoadUserData extends Component {
		state = {
			user:''
		}

		componentWillMount() {
			var controller = this;

			if (!Utils.isEmpty(window.localStorage.getItem('feathers-jwt'))) {
				API.authenticate({
					strategy: 'jwt',
					accessToken: window.localStorage.getItem('feathers-jwt')
				}).then((response) => {
						console.log(response);
							let u = response.investor;
							var payload = {
									data:{
											data: {
													'displayName': u._userFirstName + ' ' + u._userLastName,
													'photoURL'   : 'assets/images/avatars/profile.jpg',
													'email'      : u._email,
													'ident'      : u._id,
													//shortcuts    : Utils.populateFooter(u.permissions),
													settings:{}
											},
											role: JSON.parse(u._permissions)
									}
							}

							controller.props.setUserData(payload.data);
							//controller.props.setUserDataFromDB(u);
							controller.setState({user:u})

				}).catch((error) => {
                    console.log(error);
					this.props.history.push({
						pathname: '/login'
					});
				})
			}
		}

		render() {

			return <ComposedComponent user={this.state.user} dbuser={this.state.user} userid={this.state.user.id}/>
		}
	}

	function mapDispatchToProps(dispatch)
	{
		return bindActionCreators({
			setUserData: Actions.setUserData,
			setUserDataFromDB: Actions.setUserDataFromDB,
		}, dispatch);
	}

	function mapStateToProps({ fuse, auth }) {
		return {
			login: auth.login,
			user: auth.user
		}
	}

	return connect(mapStateToProps, mapDispatchToProps)(LoadUserData);
}